<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="box">
          <h1 class="title">使用モジュール</h1>
        </div>
        <table class="table is-bordered pricing__table is-fullwidth">
          <thead>
            <tr>
              <th>モジュール名</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                GPS端末設定・軌跡表示
              </td>
              <td>
                <toggle-button v-model="inputForm.module_location"
                  :value="modules.module_location"
                  @change="onChangeEventHandler"
                  color="#82C7EB"
                  height="40"
                  width="84"
                  :sync="true"
                  :labels="true"></toggle-button>
              </td>
            </tr>
            <tr>
              <td>
                モード設定・モード表示
              </td>
              <td>
                <toggle-button v-model="inputForm.module_mode"
                  :value="modules.module_mode"
                  @change="onChangeEventHandler"
                  color="#82C7EB"
                  height="40"
                  width="84"
                  :sync="true"
                  :labels="true"></toggle-button>
              </td>
            </tr>
            <tr>
              <td>
                一般投稿機能
              </td>
              <td>
                <toggle-button v-model="inputForm.module_official_task"
                  :value="modules.module_official_task"
                  @change="onChangeEventHandler"
                  color="#82C7EB"
                  height="40"
                  width="84"
                  :sync="true"
                  :labels="true"></toggle-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'

export default {
  data: function(){
    return {
      inputForm: null,
    }
  },
  created(){
    this.$set(this, "inputForm", Vue.util.extend({} , this.modules))
  },
  computed: {
    ...mapState({
      modules: state => state.auth.modules,
    })
  },
  methods: {
    onChangeEventHandler: function(){
      this.$store.dispatch('item/updateModules', { modules: this.inputForm })
    }
  },
}
</script>